import { useEffect } from "react";
import experimentation from "@pcln/experimentation";
const HandleSetiActions = ({ setiValues = [] })=>{
    useEffect(()=>{
        if (setiValues?.length) setiValues.forEach((seti)=>{
            experimentation.fireImpression(seti);
        });
    }, []);
    return null;
};
const components_HandleSetiActions = HandleSetiActions;
export { components_HandleSetiActions as default };
